import { Link } from 'react-router-dom';

const articles = [
  {
    label: 'Guide',
    title: 'Itaobuy Spreadsheet Explained: 2026 Complete Guide & Full Breakdown',
    excerpt: 'Everything you need to know about the itaobuy spreadsheet system. Learn how this powerful sourcing tool simplifies product ordering from China with step-by-step instructions.',
    link: '/itaobuy-spreadsheet-guide',
    image: 'https://readdy.ai/api/search-image?query=Modern%20laptop%20on%20light%20wooden%20desk%20displaying%20colorful%20spreadsheet%20data%20with%20coffee%20cup%20and%20notebook%20beside%20it%20bright%20window%20light%20creating%20warm%20atmosphere%20professional%20workspace%20photography&width=800&height=1067&seq=blogv2-guide-z01&orientation=portrait',
  },
  {
    label: 'Review',
    title: 'Is Itaobuy Sheet Safe or a Scam? Honest 2026 Review',
    excerpt: 'An unbiased look at the itaobuy sheet platform. We examine security, payment handling, supplier verification, and real user experiences to answer the safety question definitively.',
    link: '/itaobuy-spreadsheet-safety',
    image: 'https://readdy.ai/api/search-image?query=Close-up%20photography%20of%20a%20security%20padlock%20on%20dark%20slate%20surface%20with%20warm%20golden%20key%20beside%20it%20soft%20dramatic%20side%20lighting%20creating%20atmospheric%20shadows%20trust%20and%20protection%20concept&width=800&height=1067&seq=blogv2-review-z02&orientation=portrait',
  },
  {
    label: 'Comparison',
    title: 'Itaobuy Spreadsheet vs Traditional Agents: Which Is Better?',
    excerpt: 'A detailed head-to-head comparison of the itaobuy spreadsheet method versus conventional buying agents. See which approach saves more time and money for global buyers.',
    link: '/itaobuy-spreadsheet-guide',
    image: 'https://readdy.ai/api/search-image?query=Side%20by%20side%20photography%20of%20a%20modern%20tablet%20next%20to%20vintage%20paper%20documents%20on%20weathered%20wooden%20table%20natural%20window%20light%20old%20versus%20new%20technology%20concept%20editorial%20style&width=800&height=1067&seq=blogv2-compare-z03&orientation=portrait',
  },
  {
    label: 'Tutorial',
    title: 'How to Buy from China Easily Using Itaobuy Spreadsheet',
    excerpt: 'A practical walkthrough showing exactly how to use the itaobuy spreadsheet to source products from China. Perfect for first-time international buyers who want a clear process.',
    link: '/itaobuy-spreadsheet-beginners',
    image: 'https://readdy.ai/api/search-image?query=Hands%20typing%20on%20laptop%20keyboard%20with%20product%20catalog%20pages%20spread%20across%20light%20desk%20surface%20warm%20morning%20sunlight%20streaming%20through%20window%20hands-on%20learning%20atmosphere&width=800&height=1067&seq=blogv2-tutorial-z04&orientation=portrait',
  },
  {
    label: 'Pricing',
    title: 'Itaobuy Spreadsheet Pricing Guide: Complete Cost Breakdown 2026',
    excerpt: 'Understand exactly what you will pay when using the itaobuy spreadsheet system. We break down service fees, shipping costs, and compare total pricing against alternatives.',
    link: '/itaobuy-spreadsheet-pricing',
    image: 'https://readdy.ai/api/search-image?query=Clean%20calculator%20and%20receipts%20arranged%20on%20white%20desk%20surface%20with%20a%20small%20piggy%20bank%20warm%20natural%20lighting%20from%20above%20financial%20planning%20concept%20minimal%20aesthetic&width=800&height=1067&seq=blogv2-pricing-z05&orientation=portrait',
  },
  {
    label: 'Beginner',
    title: 'Itaobuy Spreadsheet for Beginners: Step-by-Step Tutorial',
    excerpt: 'Never sourced from China before? This beginner-friendly guide walks you through the entire itaobuy spreadsheet process from account setup to receiving your first order.',
    link: '/itaobuy-spreadsheet-beginners',
    image: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20notes%20beside%20a%20laptop%20showing%20tutorial%20screen%20on%20clean%20white%20desk%20with%20a%20potted%20succulent%20plant%20bright%20natural%20light%20learning%20atmosphere&width=800&height=1067&seq=blogv2-beginner-z06&orientation=portrait',
  },
  {
    label: 'Logistics',
    title: 'Itaobuy Spreadsheet Shipping & Logistics: The Full Guide',
    excerpt: 'How does shipping work with the itaobuy spreadsheet? Learn about consolidation warehouses, international carriers, delivery timelines, and how to track every package.',
    link: '/itaobuy-spreadsheet-shipping',
    image: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20boxes%20stacked%20neatly%20in%20a%20bright%20warehouse%20with%20natural%20skylight%20illumination%20shipping%20labels%20visible%20clean%20industrial%20aesthetic%20logistics%20photography&width=800&height=1067&seq=blogv2-shipping-z07&orientation=portrait',
  },
  {
    label: 'Comparison',
    title: 'Itaobuy Spreadsheet vs Direct Taobao Buying: Honest Analysis',
    excerpt: 'Should you use the itaobuy spreadsheet or buy directly from Taobao? We compare costs, complexity, language barriers, and overall experience for international buyers.',
    link: '/itaobuy-spreadsheet-vs-taobao',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20concept%20showing%20English%20interface%20on%20left%20versus%20Chinese%20language%20screen%20on%20right%20both%20on%20light%20desk%20surface%20natural%20lighting%20comparison%20photography&width=800&height=1067&seq=blogv2-taobao-z08&orientation=portrait',
  },
  {
    label: 'Products',
    title: 'Best Products to Source with Itaobuy Spreadsheet in 2026',
    excerpt: 'Discover which product categories offer the best margins and demand when sourcing through the itaobuy spreadsheet. Data-backed recommendations for resellers.',
    link: '/itaobuy-spreadsheet-best-products',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20assortment%20of%20trending%20fashion%20products%20including%20shoes%20accessories%20and%20clothing%20displayed%20on%20white%20pedestals%20against%20soft%20grey%20wall%20gallery%20style%20photography%20bright%20lighting&width=800&height=1067&seq=blogv2-products-z09&orientation=portrait',
  },
  {
    label: 'Tips',
    title: 'Itaobuy Spreadsheet Bulk Orders: Tips for Maximum Savings',
    excerpt: 'Learn how to maximize your savings when placing large orders through the itaobuy spreadsheet system. Consolidation strategies, negotiation tips, and shipping hacks.',
    link: '/itaobuy-spreadsheet-bulk-orders',
    image: 'https://readdy.ai/api/search-image?query=Large%20stack%20of%20neatly%20packed%20cardboard%20boxes%20in%20a%20bright%20modern%20fulfillment%20center%20with%20warehouse%20shelving%20in%20background%20natural%20overhead%20lighting%20clean%20professional%20logistics%20scene&width=800&height=1067&seq=blogv2-bulk-z10&orientation=portrait',
  },
  {
    label: 'Quality',
    title: 'Itaobuy Spreadsheet Quality Control: How Products Are Verified',
    excerpt: 'How does the itaobuy spreadsheet team ensure you receive quality products? Inside look at the inspection process, photo verification, and quality guarantee system.',
    link: '/itaobuy-spreadsheet-quality',
    image: 'https://readdy.ai/api/search-image?query=Person%20carefully%20inspecting%20a%20garment%20with%20magnifying%20glass%20on%20clean%20white%20worktable%20in%20bright%20inspection%20room%20natural%20daylight%20quality%20control%20photography%20professional%20setting&width=800&height=1067&seq=blogv2-quality-z11&orientation=portrait',
  },
  {
    label: 'Security',
    title: 'Itaobuy Spreadsheet Payment Methods & Security Deep Dive',
    excerpt: 'A comprehensive look at all payment options available with the itaobuy spreadsheet, including security measures, fraud protection, and how your money stays safe.',
    link: '/itaobuy-spreadsheet-payment',
    image: 'https://readdy.ai/api/search-image?query=Credit%20cards%20and%20mobile%20phone%20displaying%20secure%20payment%20interface%20on%20dark%20marble%20desk%20surface%20with%20soft%20ambient%20warm%20lighting%20fintech%20payment%20security%20concept%20photography&width=800&height=1067&seq=blogv2-payment-z12&orientation=portrait',
  },
];

export default function BlogCards() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-12 md:mb-16">
          <div className="flex-1">
            <h2 className="text-foreground-400 text-sm font-semibold uppercase tracking-wider mb-2">
              Sourcing Guides
            </h2>
            <p className="font-heading text-3xl md:text-4xl font-bold italic text-foreground-900">
              By Itaobuy Sheet
            </p>
          </div>
          <div className="lg:w-[55%]">
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
              In-depth articles written to help you master the itaobuy spreadsheet system. Each guide is crafted with original research and practical advice for global buyers.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article, index) => (
            <Link
              key={`${article.link}-${index}`}
              to={article.link}
              className="group block bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:scale-[1.02]"
            >
              <div className="h-[200px] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
                  {article.label}
                </span>
                <h3 className="text-foreground-900 font-bold text-sm md:text-base leading-snug mb-1.5 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1 mt-3 text-primary-600 text-xs font-semibold group-hover:gap-2 transition-all duration-200">
                  Read Article
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}